export const resolveEnvironment = (url: string) => {
    if(url.indexOf("localhost") !== -1) {
        return "local";
    } else if(url.indexOf("-test") !== -1) {
        return "test";
    } else if(url.indexOf("warszawa") !== -1) {
        return "warszawa";
    } else if(url.indexOf("bielsko-biala") !== -1) {
        return "bielsko-biala";
    } else if(url.indexOf("pszczyna") !== -1) {
        return "pszczyna";
    } else if(url.indexOf("czestochowa") !== -1) {
        return "czestochowa";
    } else if(url.indexOf("padel") !== -1) {
        return "padel";
    } else if(url.indexOf("gorzow") !== -1) {
        return "gorzow";
    } else if(url.indexOf("mkt") !== -1) {
        return "mkt";
    } else
        return "prod";
    }

let config: any = undefined;

export const getConfig = async (useLocal: boolean = false) => {

    if(useLocal) {
        return undefined;
    }

    var envName = resolveEnvironment(window.location.host);

    if(!config) {
        const m = await import('./' + envName);
        config = m.default;
    }

    return config;
    
}